<div class="form" *appNotesAppContext>
  <div class="form-date">{{ note?.createdAt | dateFormat:'date' }}</div>

  <h2 class="form-title">
    <app-icon
      class="form-heading-title-icon"
      name="notebook"
      [style.color]="note?.color"
    />
    {{ note?.title }}
  </h2>

  @if (note) {
    <app-shared-tags
      class="form-tags"
      [stitchItem]="note"
      [stateKey]="StateKey.tagsList"
    />

    <app-shared-knots
      class="form-knots"
      [stitchItem]="note"
      [stateKey]="StateKey.knotsList"
    />
  }

  <app-shared-signup-cta />

  <app-editor [data]="note?.body" [readOnly]="true" stchHighlightText />

  <div class="form-details">
    <div class="form-details-row">
      <div class="form-details-row-title">
        Add to Notebook
      </div>
      <div class="form-details-row-input">{{ note?.notebookId }}</div>
    </div>

    <div class="form-details-row">
      <div class="form-details-row-title">
        Description
      </div>
      <stch-item-description class="form-details-row-input" stchHighlightText [html]="note?.description" />
    </div>
  </div>
</div>
